<template>
	<Loading :loading="loading" class="row">
		<WordpressContentPage
			:pageSlug="pageSlug"
			class="col-12"
			:showLoading="false"
			v-on:loaded="() => {wpContentLoaded = false}"
		/>
		<div class="container">
			<div class="row col-12">
			
				<ListItem 
					v-for="(product) of items"
					:item = "product"
					:key="product.id"
					:source="'window'"
					class="col-12 col-md-3"
				/>
			</div>
		</div>

		<WordpressContentPage
			:pageSlug="pageSlug+'-bottom'"
			class="col-12"
			:showLoading="false"
			v-on:loaded="() => {wpContentLoaded = false}"
		/>

		<vue-headful
			title="Window Shop | Cherrytree"
			description="Browse some of the great savings you can have at Cherrytree"
		/>
	</Loading>
</template>

<script>

import WordpressContentPage from "@/wordpress/WordpressContentPage";
import Loading from "@/components/loading/Loading";
import { getSingleWindowItems } from "@/network/windowShopRequests";
import ListItem from "@/sections/shop/listing/ListItem";

export default {
	name: 'WindowShopWindow',
	data() {
		return {
			items: [],
			loading: true,
			wpContentLoaded: true,
		};
	},
	props: ["pageSlug", "cat"],
	components: {
		Loading,
		ListItem,
		WordpressContentPage,
	},
	created() {
		this.getData();
	},
	methods: {
		getData() {

			getSingleWindowItems({id: this.cat},
				(windowItems) => {
					this.items = Object.values(windowItems);
					this.loading = false;
				},
				(err) => {
					// console.log(err.products)
				}
			)
		}
	},
}
</script>

<style lang="scss" scoped>
	.windowShopCatHeader {
		margin-top: 40px;
	}
</style>